<!-- Date range (start and end date) -->
<div class="bb-media-player" [class.size-16-9]="size16_9">
	<div class="vc">
		<div class="message error" *ngIf="mediaError">
			{{ 'ERROR_LOADING_MEDIA' | translate }}
		</div>
		<video #media [attr.src]="trustedSrc" [attr.crossorigin]="settings?.crossorigin || 'anonymous'"
			[attr.height]="height"
			webkit-playsinline playsinline [attr.autoplay]="settings?.autoplay ? '' : null"
			[attr.preload]="settings?.preload ? settings?.preload : null"
			[style.height]="mediatype === 'audio' ? 0 : null">
			<track *ngIf="webVtt" [src]="webVtt" kind="subtitles" [srclang]="subtitle.isocode" [label]="subtitle.languagename" />
		</video>
	</div>

	<div class="media-controls">
		<div class="control-box play-pause" (click)="playPause()">
			<span [hidden]="status.playing"><i class="fa fa-play"></i></span>
			<span [hidden]="!status.playing"><i class="fa fa-pause"></i></span>
		</div>
		<div class="control-box progress">
			<bb-slider *ngIf="status.duration" class="duration-slider" [min]="0" [max]="status.duration" [step]="0.04"
				[size]="'thin'" [labelFilter]="'seconds'" [(ngModel)]="status.progress"
				(onChanged)="sliderChanged($event)"></bb-slider>
		</div>
		<div class="control-box time-display">
			<span>{{status.currentTime | seconds }}</span> /
			<span>{{status.duration | seconds }}</span>
		</div>
		<div class="control-box mute-toggle" (click)="toggleMute()">
			<span [hidden]="status.volume === 0"><i class="fa fa-volume-up"></i></span>
			<span [hidden]="status.volume !== 0"><i class="fa fa-volume-off"></i></span>
		</div>
	</div>
</div>
